<template>
	<div class="search_wrap">
		<div class="se_pc" v-if="!isPhone">
			<div class="se_pc_box">
				<div class="pcse_wrap">
					<div class="pcse_box">
						<div class="pcse_put">
							<input type="text" v-model="newsKey" placeholder="请输入关键字搜索">
							<button type="button" @click="searchBtn"></button>
						</div>
						<p class="pcse_num">{{totalNum}}条搜索结果</p>
					</div>
					<ul class="pc_news_ul">
						<li class="pc_news_li flex1" v-for="(item,index) in nesList" :key="index" @click="toDetail(item)">
							<div class="stm2_left flex3">
								<img class="youxia" src="@/images/yxjt_blue.png">
								<div class="ellip">{{ item.title }}</div>
							</div>
							<div class="stm2_right">{{ item.addtime.slice(0,10) }}</div>
						</li>
					</ul>
					<div class="fenye flex2" v-if="totalPage>0">
						<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
							@page-change="handlePageChange" />
					</div>
				</div>
			</div>
		</div>
		<div class="se_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="搜索"></Header2>
			<div class="network">
				<div class="nw_wrap">
					<div class="nw_search">
						<div class="am_list">
							<div class="am_input">
								<input type="text" v-model="newsKey" placeholder="请输入关键字搜索">
							</div>
						</div>
						<div class="am_zoom">
							<img @click="searchBtn" src="@/images/zoom2.png">
						</div>
					</div>
				</div>
				<p class="totel_num">
					共{{totalNum}}条查询结果
				</p>
				<ul class="pc_news_ul">
					<li class="pc_news_li flex1" v-for="(item,index) in nesList" :key="index" @click="toDetail(item)">
						<div class="stm2_left flex3">
							<img class="youxia" src="@/images/yxjt_blue.png">
							<div class="ellip">{{ item.title }}</div>
						</div>
						<div class="stm2_right">{{ item.addtime.slice(0,10) }}</div>
					</li>
				</ul>
				<div class="fenye" v-if="totalPage>0">
					<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
						@page-change="handlePageChange" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2,
	},
	data() {
		return {
			newsKey: '',
			nesList: [],
			currentPage: 1,
			totalNum: 0,
			totalPage: 0,
			isPhone: this.$isMobile,
		}
	},
    created() {
		if (this.$route.query.keyword) {
			this.newsKey = this.$route.query.keyword;
            this.searchBtn();
		}
	},
	methods: {
		// 新闻列表
		async searchnew() {
			var data2 = {
				keyword: this.newsKey,
				page: this.currentPage - 1,
				nums: 10,
			};
			const res = await this.$api.searchnew(data2);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.nesList = res.data;
				} else {
					this.nesList = [];
				}
			}
		},
		searchBtn() {
			if (this.newsKey.trim() == '') {
				this.$message({
					message: '请输入关键字',
					type: 'error',
					offset: 100,
					duration: 3000
				});
				return
			}
			this.currentPage = 1;
			this.nesList = [];
			this.searchnew();
		},
		toDetail(item) {
			this.$router.push("/news/newsDetail?id=" + item.id + '&sort=' + item.status);
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.searchnew();
		},
	}
}
</script>

<style lang="scss">
.search_wrap {
	.se_pc {
		padding-top: 80px;
		padding-bottom: 80px;
		background-color: #f1f1f1;
		min-height: 800px;
		.se_pc_box {
			max-width: 1200px;
			min-width: 950px;
			margin: 65px auto;
			padding: 104px 20px 90px;
			background-color: hsla(0, 0%, 100%, 0.6);
			min-height: 680px;
			box-sizing: border-box;
			.pcse_wrap {
				max-width: 860px;
				margin: 0 auto;
				.pcse_box {
					.pcse_put {
						display: flex;
						align-items: center;
						background-color: #fff;
						box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
						height: 69px;
						input {
							flex: 1;
							color: #262626;
							font-size: 28px;
							height: 69px;
							padding: 0 42px;
							border: none;
							outline: none;
							margin-right: 2px;
						}
						button {
							width: 88px;
							flex-shrink: 0;
							height: 69px;
							background-image: url("../../images/zoom2.png");
							background-repeat: no-repeat;
							background-position: 50%;
							border: none;
							outline: none;
							background-color: #fff;
							cursor: pointer;
						}
					}
					.pcse_num {
						color: #666;
						font-size: 22px;
						padding: 10px 42px 0;
						margin-bottom: 32px;
						text-align: left;
					}
				}
				.pc_news_ul {
					.pc_news_li {
						width: 100%;
						box-sizing: border-box;
						cursor: pointer;
						align-items: flex-end;
						padding: 25px 0;
						border-bottom: 1px dashed #eee;
						&:hover {
							.stm2_left {
								div {
									color: #003f99;
								}
							}
							.stm2_right {
								color: #003f99;
							}
						}
						.stm2_left {
							flex: 1;
							.youxia {
								width: 20px;
								color: #ff8041;
								font-weight: bold;
								margin-top: 5px;
							}
							div {
								flex: 1;
								width: 0;
								margin-left: 15px;
								font-size: 18px;
								color: #8c8c8c;
							}
						}
						.stm2_right {
							margin-left: 20px;
							font-size: 17px;
							color: #8c8c8c;
						}
					}
				}
				.fenye {
					margin-top: 30px;
				}
			}
		}
	}
	@media screen and (max-width: 1400px) {
		.se_pc {
			.se_pc_box {
				width: 1000px;
			}
		}
	}
	@media screen and (max-width: 1300px) {
		.se_pc {
			.se_pc_box {
				width: 900px;
			}
		}
	}
	.se_phone {
		background-color: #f1f1f1;
		padding: 1.2rem 0 2.5rem 0;
		min-height: 90vh;
		.network {
			.nw_wrap {
				padding: 0.4rem 0.53rem 0.47rem;
				box-sizing: border-box;
				.nw_search {
					background-color: #fff;
					height: 1.17rem;
					padding: 0 0.33rem;
					border-radius: 1.17rem;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.am_list {
						box-sizing: border-box;
						flex: 1;
						.am_input {
							input {
								color: #666;
								font-size: 17px;
								width: 100%;
								height: 1.17rem;
								border-radius: 1.17rem;
								background-color: #fff;
								border: none;
								outline: none;
							}
						}
					}
					.am_zoom {
						width: 1rem;
						text-align: center;
						img {
							width: 0.45rem;
						}
					}
				}
			}
			.totel_num {
				padding: 0 0.53rem;
				color: #666;
				text-align: left;
			}
			.pc_news_ul {
                padding: 0 0.35rem 0.35rem 0.35rem;
				.pc_news_li {
					width: 100%;
					box-sizing: border-box;
					cursor: pointer;
					align-items: flex-end;
					padding: 0.5rem 0;
					border-bottom: 1px dashed #ccc;
					&:hover {
						.stm2_left {
							div {
								color: #003f99;
							}
						}
						.stm2_right {
							color: #003f99;
						}
					}
					.stm2_left {
						flex: 1;
						.youxia {
							width: 0.5rem;
							color: #ff8041;
							font-weight: bold;
							margin-top: 5px;
						}
						div {
							flex: 1;
							width: 0;
							margin-left: 0.35rem;
							font-size: 0.4rem;
							color: #8c8c8c;
						}
					}
					.stm2_right {
						margin-left: 0.5rem;
						font-size: 0.4rem;
						color: #8c8c8c;
					}
				}
			}
			.fenye {
				margin-top: 0.3rem;
				display: flex;
				justify-content: center;
			}
		}
	}
}
</style>